import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'VehicleReport',
    initialState: {
        isRequesting: false,
        error: null,
        data: {},
        searchCriteria: {},
    },
    reducers: {
        get_vehicle_report: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload }
            };
        },
        get_vehicle_report_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload
            };
        },
        get_vehicle_report_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: {}
            };
        },
        export_vehicle_report: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload }
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;